import React, { useEffect, useState, useRef } from 'react';
import {
    Row, Col, Button, ProTableOt, useProTableOt, setParamsFilter, Input, Form, AspectRatio,
    Accordion, AccordionItem, AccordionTrigger, AccordionContent, Tabs,
    Badge, ImageFileId, Tag
} from '../../ui/ot'
import { useSearchParams, useNavigate } from "react-router-dom";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import AdvancedSearchForm from './advanced_search_form'
import useWindowSize from '../controllers/window_size';
import { useBib } from '../../koha/controllers/bib_controller';
import { Card, CardContent, CardHeader } from "../../ui/card"
import { Checkbox } from "../../ui/checkbox"
import { Label } from "../../ui/label"
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import { X } from "lucide-react"
import styled from 'styled-components';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../../ui/carousel"
function SearchFunction({
    keyPrefix = "library.online_public_catalog_query_construction.collection_search",
    prefixRoute = ''
}) {
    const navigate = useNavigate();
    const { t } = useTranslation('translation', { keyPrefix })

    const [advancedSearch, setAdvancedSearch] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const { width, height } = useWindowSize();
    const [selectedSearch, setSelectedSearch] = useState(null); // 館藏區選擇
    const [tableSearchParams, setTableSearchParams] = useState({
        branchcode_arr: [],
        ...Object.fromEntries(searchParams.entries()),
    });

    const [showMode, setShowMode] = useState("cardPage")
    const styles = {
        searchContainer: {
            margin: '20px',
            justifyContent: 'center',
            alignItems: 'center',
        },
        selectStyle: {
            backgroundColor: 'white',
            border: '2px solid #2f7c9d',
            color: '#2f7c9d',
            borderRadius: '50px',
            width: '100%',
            textAlign: 'center',
            padding: '5px',
        },
        searchInput: {
            borderRadius: '50px',
            border: '2px solid #2f7c9d',
            padding: '5px 20px',
            width: '100%',
        },
        searchButton: {
            backgroundColor: '#f28d35',
            border: 'none',
            borderRadius: '50px',
            padding: '5px 20px',
            color: 'white',
            width: '100%',
        },
        informationButton: {
            backgroundColor: '#f28d35',
            border: 'none',
            borderRadius: '50px',
            padding: '5px 20px',
            color: 'white',
            width: '20%',
        },
        cardStyle: {
            marginTop: '20px',
            border: '1px solid #eaeaea',
            borderRadius: '10px',
            padding: '15px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
        titleStyle: {
            fontSize: '1.2rem', // 調整字體大小
            fontWeight: 'bold', // 設置粗體
        },
        imageStyle: {
            width: 'auto',
            // height: 'auto',
            height: "14em",
            // width: "14em",
        },
        paginationButton: {
            margin: '5px',
            padding: '5px 10px',
            border: '1px solid #2f7c9d',
            borderRadius: '5px',
            cursor: 'pointer',
        },
        disabledButton: {
            margin: '5px',
            padding: '5px 10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            cursor: 'not-allowed',
            color: '#ccc',
        },
        activeButton: {
            backgroundColor: '#2f7c9d',
            color: 'white',
            border: '2px solid #2f7c9d',
            borderRadius: '20px',
            width: '100%',
            margin: '5px 0',
        },
        inactiveButton: {
            backgroundColor: 'white',
            color: '#2f7c9d',
            border: '2px solid #2f7c9d',
            borderRadius: '20px',
            width: '100%',
            margin: '5px 0',
        },
        sectionTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
        },
        buttonGroup: {
            margin: '5px 0',
        }
    };
    const [advanced_search_form] = Form.useForm(); //form 
    const [form] = Form.useForm(); //form 

    const actionRef = useRef(null); //要呼叫ProTableOt 的 function 所需要的，想知道原理請去查詢 forwardRef, useImperativeHandle, 
    const lastRequestedPageRef = useRef(null);
    const columns = [
        {
            title: `${t('bib_title')}`,
            dataIndex: "bib_title",
            key: "bib_title",
            width: "400px"
        },
        {
            title: `${t('import_bibliography_date')}`,
            dataIndex: "bib_datecreated",
            key: "bib_datecreated",
        },
        {
            title: `${t('classification_number')}`,
            dataIndex: "bibitem_cn_class",
            key: "bibitem_cn_class",
        },
        {
            title: `${t('author_number')}`,
            dataIndex: "bibitem_cn_item",
            key: "bibitem_cn_item",
        },
        {
            title: `${t('import_bibliography_date')}`,
            dataIndex: "bib_datecreated",
            key: "bib_datecreated",
        },
        {
            title: `${t('Author')}`,
            dataIndex: "bib_author",
            key: "bib_author",
        },
        {
            title: `${t('bib_translator')}`,
            dataIndex: "bib_translator",
            key: "bib_translator",
        },

        {
            title: `${t('Material_type')}`,
            dataIndex: "bib_materialType",
            key: "bib_materialType",
        },
        {
            title: `${t('Series')}`,
            dataIndex: "bib_seriestitle",
            key: "bib_seriestitle",
            render: (text, record, index) => {
                return <>{record?.bib_seriestitle} {record?.bibitem_volume}</>
            }
        },
        {
            title: `${t('Publication_details')}`,
            dataIndex: "bib_publisher",
            key: "bib_publisher",
        },
        {
            title: `${t('Description')}`,
            dataIndex: "bib_notes",
            key: "bib_notes",
        },
        {
            title: `${t('ISBN')}`,
            dataIndex: "bibitem_isbn",
            key: "bibitem_isbn",
        },
        {
            title: `${t('Edition')}`,
            dataIndex: "bibitem_editionstatement",
            key: "bibitem_editionstatement",
        },
        {
            title: `${t('Other_title')}`,
            dataIndex: "bib_othertitle",
            key: "bib_othertitle",
            render: (text, record, index) => {
                return <>{text?.join('、')}</>
            }
        },
        {
            title: ``,
            dataIndex: "bibitem_editionstatement",
            key: "bibitem_editionstatement",
            render: (text, record, index) => {
                return (<Button
                    // style={styles.informationButton}
                    onClick={() => {
                        window.open(`.${prefixRoute}/collection_search/?biblionumber=${record?.bib_biblionumber}`, 'blank')
                    }}
                >
                    館藏資訊
                </Button>)
            }
        },

    ];
    const keyLabelMap = {
        bib_language: "語言",
        bib_author: "作者",
        bib_othertitle: "其他書名",
        bib_seriestitle: "叢書系列",
        bibitem_itemtype_description: "館藏分類",
        home_branch: "館藏地"
    };


    const [postCoordinateSearching, setPostCoordinateSearching] = useState(null)
    const handleCollectionClick = (value) => {
        setTableSearchParams((pre) => {
            let preBranchcodeArr = [...pre?.branchcode_arr]
            if (preBranchcodeArr.includes(value)) {
                preBranchcodeArr = preBranchcodeArr.filter((ele) => ele !== value)
                return {
                    ...pre,
                    branchcode_arr: [...preBranchcodeArr]
                }
            }
            else {
                return {
                    ...pre,
                    branchcode_arr: [...preBranchcodeArr, value]
                }
            }

        })
    };


    const onSubmit = (values) => {
        console.log(values)


        setTableSearchParams((pre) => {
            return {
                // keyword: values?.keyword,
                custom_filter_value: values?.search,
                search: values?.search,
                field: values?.field,
                branchcode_arr: pre?.branchcode_arr,
            }
        })

        // navigate(`${propsNavigateSearchPath}?` + new URLSearchParams(values));
    };

    const bibController = useCRUDController({
        apiRoute: "/koha/bib",
    })
    const libraryController = useCRUDController({
        apiRoute: "/koha/library",
        // onBefore: ()=>{},
        // onFinish: onFinish,
    })
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    const {
        BibData,
        getBibData,
        getBibInfoFormat
    } = useBib({
        onFinish: () => { },
        onBefore: () => { }
    })

    const scrollToPageTop = () => {
        window.requestAnimationFrame(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    };



    useEffect(() => {
        checkAll();
        libraryController.getData({})
    }, []);
    useEffect(() => {
        let searchValue = { ...Object.fromEntries(searchParams.entries()) }
        form.setFieldsValue({ ...searchValue })
        if (!!searchValue?.operator2) {
            setAdvancedSearch(true)
        }
        advanced_search_form.setFieldsValue({
            search: [
                {
                    operator: searchValue?.operator,
                    field: searchValue?.field,
                    keyword: searchValue?.search,
                },
                {
                    operator: searchValue?.operator2,
                    field: searchValue?.field2,
                    keyword: searchValue?.keyword2,
                },
                {
                    operator: searchValue?.operator3,
                    field: searchValue?.field3,
                    keyword: searchValue?.keyword3,
                },
            ]
        })
    }, [searchParams])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    useEffect(() => {
        if (width <= 430) {
            setShowMode('card')
        }
        else {
            setShowMode('cardPage')
        }
    }, [width])
    useEffect(() => {
        if (showMode === "card") {
            actionRef.current.reloadAndRest()
        }
        else {
            actionRef.current.reload()
        }
    }, [showMode])
    return (
        <div style={styles.searchContainer}>
            <Col span={24}>
                <Row gutter={[8, 8]} justify="center">
                    <Col span={24}>
                        <Form
                            form={form}
                            onValuesChange={() => { }}
                            onFinish={onSubmit}
                            autoComplete="off"
                            initialValues={{
                                type: "0"
                            }}
                        >
                            <Row justify="center" gutter={[8, 8]}>
                                {/* 輸入框 */}
                                <Col xxl={18} xl={18} lg={18} md={18} sm={16} xs={24}>
                                    <Form.Item
                                        name="search"
                                        rules={[{ required: true, message: "請輸入" }]}
                                        style={{ marginBottom: 0 }}
                                    >
                                        <Input
                                            placeholder="輸入關鍵字、書名、ISBN、作者、分類號、館藏條碼"
                                            className="inputBorder"
                                            style={{
                                                height: "48px",
                                                fontSize: "16px",
                                                paddingLeft: "16px",
                                                borderRadius: "8px",
                                                borderColor: "#d1d5db",
                                            }}
                                        />
                                    </Form.Item>
                                </Col>

                                {/* 查詢按鈕 */}
                                <Col >
                                    <SearchButton
                                        onClick={() => {
                                            setSelectedSearch(null);
                                            if (advancedSearch) {
                                                advanced_search_form.submit();
                                            } else {
                                                form.submit();
                                            }
                                        }}
                                    >
                                        查詢
                                    </SearchButton>
                                </Col>

                                {/* 進階/一般切換按鈕 */}
                                <Col >
                                    <ToggleButton
                                        $advanced={advancedSearch}
                                        onClick={() => {
                                            setAdvancedSearch((pre) => {
                                                if (pre) {
                                                    advanced_search_form.setFieldsValue({
                                                        search: [{ field: "keyword", keyword: null }],
                                                    });
                                                }
                                                return !pre;
                                            });
                                        }}
                                    >
                                        {advancedSearch ? "一般查詢" : "進階查詢"}
                                    </ToggleButton>
                                </Col>
                            </Row>

                        </Form>
                    </Col>
                    {advancedSearch &&
                        <Col xxl={20} xl={20} lg={20} md={22} sm={24} xs={24}>
                            <AdvancedSearchForm
                                propsForm={advanced_search_form}
                                onFormFinish={(formValue) => {
                                    let { search } = formValue
                                    let values = {}
                                    console.log({ values })
                                    search?.forEach((element, index) => {
                                        if (!!index) {
                                            values[`field${index + 1}`] = element?.field
                                            values[`keyword${index + 1}`] = element?.keyword
                                            values[`operator${index + 1}`] = element?.operator
                                        }
                                        else {
                                            values[`field`] = element?.field
                                            values[`keyword`] = element?.keyword
                                        }
                                    });
                                    setTableSearchParams((pre) => {
                                        return {
                                            ...values,
                                            branchcode_arr: pre?.branchcode_arr,
                                        }
                                    })
                                }}
                            />
                        </Col>
                    }
                </Row>
            </Col>
            <Col span={24}>
                <Row gutter={[8, 8]} justify="center">
                    <Col xxl={6} xl={6} lg={6} md={8} sm={24} xs={24}>
                        <Accordion defaultValue={width <= 430 ? null : "show"} type="single" collapsible>
                            <AccordionItem value={"show"}>
                                <AccordionTrigger><p style={{ fontSize: '25px', fontWeight: 'bold', paddingTop: '15px', paddingBottom: '10px' }}> 篩選</p></AccordionTrigger>
                                <AccordionContent>
                                    <Row>
                                        {postCoordinateSearching &&
                                            <Col span={24}>
                                                <div>
                                                    <Card className="border-library-200 shadow-sm sticky top-4">
                                                        <CardHeader className="bg-gradient-to-r from-library-50 to-library-100 rounded-t-lg">
                                                            <div className="flex justify-between items-center">
                                                                <Button
                                                                    onClick={() => {
                                                                        actionRef.current.reloadAndRest()
                                                                    }}
                                                                    variant="ghost" size="sm"  >套用篩選</Button>
                                                                <Button
                                                                    onClick={() => {
                                                                        setSelectedSearch(null)
                                                                    }}
                                                                    variant="ghost" size="sm" className="h-8 px-2 text-library-700 hover:bg-library-100">
                                                                    <X className="h-4 w-4 mr-1" />
                                                                    清除全部
                                                                </Button>
                                                            </div>
                                                        </CardHeader>
                                                        <CardContent className="p-4">
                                                            <Accordion type="multiple" defaultValue={Object.keys(postCoordinateSearching)} className="space-y-2">
                                                                {/* 特例處理：出版年份 */}
                                                                {"bib_copyright_min_time" in postCoordinateSearching && "bib_copyright_max_time" in postCoordinateSearching && (
                                                                    <AccordionItem value="year" className="border-library-200">
                                                                        <AccordionTrigger className="text-library-800 hover:text-library-600 py-2">出版年份</AccordionTrigger>
                                                                        <AccordionContent>
                                                                            <div className="space-y-4 px-1">
                                                                                <div className="flex justify-between text-sm text-library-700">
                                                                                    <span>{postCoordinateSearching?.bib_copyright_min_time}</span>
                                                                                    <span>{postCoordinateSearching?.bib_copyright_max_time}</span>
                                                                                </div>
                                                                                <div className="flex justify-between gap-2">
                                                                                    <Input
                                                                                        type="number"
                                                                                        placeholder="最小"
                                                                                        defaultValue={parseInt(postCoordinateSearching?.bib_copyright_min_time)}
                                                                                        className="w-full border-library-200"
                                                                                    />
                                                                                    <span className="flex items-center text-library-500">-</span>
                                                                                    <Input
                                                                                        type="number"
                                                                                        placeholder="最大"
                                                                                        defaultValue={parseInt(postCoordinateSearching?.bib_copyright_max_time)}
                                                                                        className="w-full border-library-200"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </AccordionContent>
                                                                    </AccordionItem>
                                                                )}

                                                                {/* 一般資料 map 產生 */}
                                                                {Object.entries(postCoordinateSearching).map(([key, value]) => {
                                                                    // 過濾掉非陣列 or 已經處理過的 key
                                                                    if (!Array.isArray(value) || key.startsWith("bib_copyright")) return null;

                                                                    const title = keyLabelMap[key] || key; // fallback title
                                                                    const idPrefix = key.replace(/[^a-zA-Z0-9]/g, ""); // clean ID base

                                                                    return (
                                                                        <AccordionItem key={key} value={key} className="border-library-200">
                                                                            <AccordionTrigger className="text-library-800 hover:text-library-600 py-2">{title}</AccordionTrigger>
                                                                            <AccordionContent>
                                                                                <div className="grid gap-2 pl-1">
                                                                                    {value.map((item, index) => (
                                                                                        <div key={index} className="flex items-center space-x-2">
                                                                                            <Checkbox
                                                                                                checked={selectedSearch?.[key] ? selectedSearch?.[key].includes(item?.item_name) : false}
                                                                                                onCheckedChange={(checked) => {
                                                                                                    setSelectedSearch((pre) => {
                                                                                                        let old = { ...pre }
                                                                                                        if (checked) {
                                                                                                            let objArray = old?.[key] || []
                                                                                                            objArray.push(item?.item_name)
                                                                                                            return {
                                                                                                                ...pre,
                                                                                                                [key]: objArray
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            let objArray = [...old[key]]
                                                                                                            objArray = objArray.filter((ele) => ele !== item?.item_name)
                                                                                                            return {
                                                                                                                ...pre,
                                                                                                                [key]: objArray
                                                                                                            }
                                                                                                        }
                                                                                                    })
                                                                                                }}
                                                                                                id={`${idPrefix}-${index}`} className="border-library-300" />
                                                                                            <Label htmlFor={`${idPrefix}-${index}`} className="flex items-center text-sm font-normal cursor-pointer">
                                                                                                {item?.item_name}
                                                                                                <Badge className="ml-2 bg-library-100 text-library-700 hover:bg-library-200">{item?.item_value}</Badge>
                                                                                            </Label>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </AccordionContent>
                                                                        </AccordionItem>
                                                                    );
                                                                })}
                                                            </Accordion>
                                                        </CardContent>

                                                    </Card>
                                                </div>
                                            </Col>}
                                    </Row>
                                </AccordionContent>
                            </AccordionItem>
                        </Accordion>
                    </Col>

                    <Col xxl={18} xl={18} lg={18} md={16} sm={24} xs={24}>
                        <Row justify={"end"}>
                            <Col >
                                <Tabs
                                    items={[
                                        {
                                            key: "cardPage",
                                            tab: "圖文顯示"
                                        },
                                        {
                                            key: "page",
                                            tab: "條列顯示"
                                        },

                                    ]}
                                    onChange={(val) => {
                                        setShowMode(val)
                                    }}>
                                </Tabs>
                            </Col>
                            <Col span={24}>
                                <ProTableOt
                                    searchParams={{
                                        ...tableSearchParams,
                                        ...selectedSearch
                                    }}
                                    showSearch={false}
                                    reloadButton={false}
                                    manageColumnsButton={false}
                                    rowKey={"bib_biblionumber"}
                                    actionRef={actionRef}
                                    columns={columns}
                                    check={check}
                                    setCheck={setCheck}
                                    request={async (params = {}, sort, filter) => {
                                        const currentPage = Number(params?.current || 1);
                                        const shouldScrollToTop = showMode === "page" || showMode === "cardPage";
                                        if (shouldScrollToTop && lastRequestedPageRef.current !== null && lastRequestedPageRef.current !== currentPage) {
                                            scrollToPageTop();
                                        }
                                        lastRequestedPageRef.current = currentPage;

                                        let newParams = {};
                                        let order = setOrders(sort);
                                        let defaultDate = {
                                            datecreated_start: '1900-01-01',
                                            datecreated_end: dayjs().endOf('year').format('YYYY-MM-DD'),
                                        }
                                        let newTableSearchParams = {
                                            ...defaultDate,
                                            ...tableSearchParams,
                                            ...selectedSearch
                                        }
                                        newParams = {
                                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                            ...newParams,
                                            order,
                                            size: params.pageSize,
                                            cur_page: params.current,
                                            ...newTableSearchParams
                                        };
                                        newParams = setParamsFilter({
                                            ...newParams,
                                        });
                                        return bibController.getData({
                                            ...newParams,
                                        }, {
                                            useCancelToken: true
                                        }).then((response) => {
                                            console.log({
                                                response
                                            })
                                            setPostCoordinateSearching(response?.post_coordinate_searching)
                                            return {
                                                ...response
                                            }
                                        });
                                    }}

                                    rowSelection={false}
                                    manage_columns={true}
                                    showMode={showMode} // page || infiniteScroll || card,
                                    cardRender={(record) =>
                                        BibCardFunction(record, t, getBibInfoFormat, styles, prefixRoute)

                                    }

                                    cardModeSetting={{
                                        columnsCount: 1,
                                        singleRowHeight: 100,
                                    }}
                                />
                            </Col>
                        </Row>

                    </Col>
                </Row>

            </Col>
        </div>
    );
}

export default SearchFunction;

// --- Styled Components ---
const StyledCard = styled(Card)`
  padding: 12px;
  transition: transform 0.3s, box-shadow 0.3s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
`;

const BookImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
`;

const Title = styled.h4`
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.4;
`;

const InfoText = styled.p`
  font-size: 13px;
  color: #4b5563;
  margin: 0;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LabelStyle = styled.span`
  font-weight: bold;
  margin-right: 4px;
`;

const StrongText = styled.p`
  font-size: 13px;
  font-weight: bold;
  margin: 0;
  line-height: 1.4;
`;

const ActionButton = styled(Button)`
  margin-top: 6px;
`;

// --- Main Component ---
const BibCardFunction = (record, t, getBibInfoFormat, styles,prefixRoute) => {
  
    let fileId = record?.bib_cover_images || []
    let file_id = fileId.map((val) => {
        return {
            file_id: val
        }
    })
    let bookImageData = []
    if (file_id.length > 0) {
        bookImageData = file_id
    }
    else {
        bookImageData = [
            {
                src: "https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=" + record?.bibitem_isbn
            },
        ]
    }


    return (
        <StyledCard style={styles?.cardStyle}>
            <Row gutter={[6, 6]} align="top">
                {/* 左側：書封面 */}
                <Col xxl={3} xl={4} lg={5} md={6} sm={8} xs={24}>
                    <div className="w-full max-w-4xl mx-auto px-1">
                        <Carousel
                            className="w-full"
                            opts={{
                                align: "start",
                                loop: true,
                            }}
                        >
                            <CarouselContent>
                                {bookImageData.map((book, index) => (
                                    <CarouselItem key={book.id} >
                                        <AspectRatio ratio={3 / 4} className="bg-muted">
                                            {
                                                book?.file_id ?
                                                    <ImageFileId
                                                        file_id={book?.file_id}
                                                        className="w-full rounded-md object-cover"

                                                    />
                                                    :
                                                    <ImageFileId
                                                        src={book?.src}
                                                        // file_id={book?.file_id}
                                                        className="w-full rounded-md object-cover"

                                                    />
                                            }

                                        </AspectRatio>
                                    </CarouselItem>
                                ))}
                            </CarouselContent>
                            <div className="flex items-center justify-center gap-2 mt-4">
                                <CarouselPrevious className="static transform-none" />
                                {/* <div className="text-sm">
                                    {current + 1} / {bookImageData.length}
                                </div> */}
                                <CarouselNext className="static transform-none" />
                            </div>
                        </Carousel>
                    </div>
                    {/* <AspectRatio ratio={3 / 4}>
                        <BookImage
                            src={`https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=${record?.bibitem_isbn}`}
                            alt="book cover"
                        />
                    </AspectRatio> */}
                </Col>

                {/* 右側：書籍資訊 */}
                <Col xxl={21} xl={20} lg={19} md={18} sm={16} xs={24}>
                    <Row gutter={[4, 4]}>
                        {/* 書名 */}
                        <Col span={24}>
                            {getBibInfoFormat().map((val, idx) => {
                                if (val?.language_name === "bib_title") {
                                    return (
                                        <Title key={`title-${idx}`}>
                                            {val?.valueKeys.map((keysValue) => record?.[keysValue])}
                                        </Title>
                                    );
                                }
                                return null;
                            })}
                        </Col>

                        {/* 其他欄位 */}
                        {getBibInfoFormat().map((val, idx) => {

                            if (val?.language_name !== "bib_title") {

                                if (val?.language_name === "Language") {
                                    return <Col span={12} key={`info-${idx}`}>
                                        <InfoText>
                                            <LabelStyle>{t(`${val?.language_name}`)}：</LabelStyle>
                                            {val?.valueKeys.map((keysValue) => {
                                                return record?.[keysValue]?.["Language"];
                                            })}
                                        </InfoText>
                                    </Col>
                                }
                                else if (val?.language_name === "online_resources") {
                                    return <Col span={12} key={`info-${idx}`}>
                                        <InfoText>
                                            <LabelStyle>{t(`${val?.language_name}`)}：</LabelStyle>
                                            <a className="text-blue-600 hover:text-blue-800 p-0 h-auto" href={record?.bib_electronic_location}>{record?.bib_electronic_location_name}</a>
                                        </InfoText>
                                    </Col>
                                }
                                else {
                                    return <Col span={12} key={`info-${idx}`}>
                                        <InfoText>
                                            <LabelStyle>{t(`${val?.language_name}`)}：</LabelStyle>
                                            {val?.valueKeys.map((keysValue) => {
                                                return val?.isJoin
                                                    ? record?.[keysValue]?.join('、')
                                                    : record?.[keysValue];
                                            })}
                                        </InfoText>
                                    </Col>
                                }
                            }
                            return null;
                        })}

                        {/* 館藏量 */}
                        <Col span={12}>
                            <InfoText>
                                <LabelStyle>館藏資訊：</LabelStyle>
                                 {record?.authorised.length === 0 && <>無館藏</>}
                                 {record?.authorised?.map((val) => {
                                     return<>{val?.name}:{val?.count}本</>
                                })}
                            </InfoText>
                        </Col>

                        {/* 館藏資訊按鈕 */}
                        <Col span={24} style={{ textAlign: "right" }}>
                            <ActionButton
                                size="small"
                                onClick={() => {
                                    window.open(`.${prefixRoute}/collection_search/?biblionumber=${record?.bib_biblionumber}`, '_blank');
                                }}
                            >
                                館藏資訊
                            </ActionButton>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </StyledCard>
    );
};

const SearchButton = styled(Button)`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background-color: #2563eb;
  color: white;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: background-color 0.3s, box-shadow 0.3s;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #1d4ed8;
  }

  @media (max-width: 576px) {
    font-size: 14px;
    height: 44px;
  }
`;

const ToggleButton = styled(Button)`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background-color: ${props => props.$advanced ? '#10b981' : '#3b82f6'};
  color: white;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.$advanced ? '#059669' : '#2563eb'};
  }

  @media (max-width: 576px) {
    font-size: 14px;
    height: 44px;
  }
`;
